<ion-header class="m-bctx-selection-header">
  <ion-row class="m-bctx-selection-header__content ion-justify-content-between">
    <div>{{ header | translate }}</div>
    <div class="exit-button" (click)="closeModal()" *ngIf="!hideExit">
      <ion-img [src]="exitIcon" class="exit-button__icon"></ion-img>
      <div>
        {{ 'input_app_common.exit' | translate }}
      </div>
    </div>
  </ion-row>
</ion-header>
<ion-content class="m-bctx-selection-content" [ngClass]="{ 'm-bctx-selection-content--no-footer': !enableProceed }">
  <div class="allocate-from" *ngIf="selectedBctxItem && selectedBctxItem.length && selectedBctxItem[0]?.list?.length">
    <ion-row> <span class="allocate">Allocate </span> <span style="font-weight: bolder"> FROM</span> </ion-row>
    <ion-row class="selected-bctx">
      <ion-col *ngFor="let item of selectedBctxItem[0].list">
        <span>{{ bctxKeysToDisplayMap[item.k] | translate }}</span> :
        <span style="font-weight: bolder">{{ item.v }}</span>
      </ion-col>
    </ion-row>
  </div>
  <div class="m-bctx-selection-content__filter">
    <ui-filter
      [fiterGroupModel]="bctxListingFilterGroupModel"
      (updatedFilter)="onUpdateFilter($event)"
      [filterStyles]="[80, 2, 18]"
      [scrollableX]="true"
    >
      <ng-container ngProjectAs="[bulk-table-action]" *ngIf="!hideSync">
        <ui-custom-button
          [btnTxt]="'input_app_common.sync' | translate"
          [iconSrc]="syncIcon"
          [buttonHeight]="'36px'"
          [buttonType]="'TERITIARY'"
          (clickEvent)="handleSync()"
        ></ui-custom-button>
      </ng-container>
    </ui-filter>
  </div>
  <div class="m-bctx-selection-content__pagination">
    <monorepo-listing-pagination
      [paginationInfo]="paginationInfo"
      [paginationOption]="userPaginationOption"
      (updateUserPaginationTuple)="updateUserPagination($event)"
    ></monorepo-listing-pagination>
  </div>
  <div class="m-bctx-selection-content__table">
    <ui-table
      [cellTextAlign]="'middle'"
      [zTableModel]="tableBctxListingModel"
      (onSelectRow)="onTableSelect($event)"
      [cellSize]="'LARGE'"
    >
    </ui-table>
  </div>
</ion-content>
<ion-footer>
  <ion-row
    *ngIf="enableProceed && buttonList.length == 0"
    class="m-bctx-selection-footer m-bctx-selection-footer-with-one-btn"
    [ngClass]="{ 'm-bctx-selection-footer--disabled': !selectedBctxItems.length }"
    (click)="sendChangeBctxEvent()"
    >{{ buttonTxt.length ? buttonTxt : ('input_app_common.proceed' | translate) }}
    <ion-img *ngIf="!buttonTxt.length" [src]="proceedIcon" class="proceed-icon"></ion-img
  ></ion-row>
  <ion-row
    *ngIf="enableProceed && buttonList.length != 0"
    class="m-bctx-selection-footer"
    [ngClass]="{ 'm-bctx-selection-footer--disabled': !selectedBctxItems.length }"
  >
    <ion-col
      class="btn"
      *ngFor="let btn of buttonList"
      (click)="sendChangeBctxEventForButtonList(btn)"
      class="{{ btn.class }}"
      >{{ btn.name }}</ion-col
    >
  </ion-row>
  <ion-row *ngIf="!enableProceed" class="m-bctx-selection-footer--empty"></ion-row>
</ion-footer>
